import "./polyfill";
import "regenerator-runtime";
import "whatwg-fetch";

import { registerRootComponent } from "expo";
import App from "./src/OS/App";
import { withErrorBoundary } from "@sentry/react-native";

registerRootComponent(withErrorBoundary(App));
